import React, { useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Text, View } from 'styles/reactnative'
import { Input } from 'antd'

const PhoneSelect = ({ phone, setPhone, phoneCode, setPhoneCode }) => {
	const [dropdownOpen, setDropdownOpen] = useState(false)

	return (
		<View
			style={{
				flexDirection: 'row',
				justifyContent: 'flex',
				alignItems: 'flex-start',
			}}>
			<PhoneInput
				showDropdown={dropdownOpen}
				country={'kr'}
				placeholder="Phone Number"
				value={phoneCode}
				onChange={(value, country: any) => {
					// setMobile({
					// 	...mobile,
					// 	country_code: country?.countryCode,
					// 	iso_code: country.dialCode,
					// })
					setPhoneCode(country.dialCode)
				}}
				containerStyle={{ width: 60 }}
				inputStyle={{
					display: 'none',
					padding: 0,
					margin: 0,
					position: 'absolute',
					height: '0%',
					width: '0%',
					background: '#f1f1f1',
				}}
				buttonStyle={{
					background: '#f1f1f1',
					padding: 0,
					width: 38,
					height: 34,
					border: 'none',
				}}
			/>
			<View
				onClick={() => {
					setDropdownOpen(true)
				}}
				style={{
					height: 34,
					background: '#f1f1f1',
					color: '#000',
					borderTopRightRadius: 5,
					borderBottomRightRadius: 5,
					width: 45,
					cursor: 'pointer',
				}}>
				<Text size={14} style={{ color: '#000' }}>
					{phoneCode}
				</Text>
			</View>
			<Input
				value={phone}
				type={'text'}
				placeholder="Phone Number"
				onChange={e => {
					setPhone(e.target.value)
				}}
				style={{ marginLeft: 10, height: 34 }}
			/>
		</View>
	)
}

export default PhoneSelect
